var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.9,
    y: 47.27,
    width: 85.46,
    height: 141.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.06,
    y: 47.27,
    width: 85.46,
    height: 141.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: 50.14,
    width: 78.18,
    height: 135.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.58,
    y: 67.77,
    width: 48.07,
    height: 100.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,132.67c-.11-9.38,8.33-18.54,17.62-19.85,4.43-.62,9.14.26,13.28-1.44,7.39-3,9.74-12.85,17.18-15.76l.34,72.6H56.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.67 54.44 464.67 122.27 367.25 122.27 363.74 54.91 464.67 54.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.85,
    y: 39.81,
    width: 67.21,
    height: 97.42,
    transform: "translate(323.93 500.97) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.63,122.59H363.28V54.45h98.35Zm-97.42-.93H460.7V55.38H364.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.29,
    y: 63.26,
    width: 76.32,
    height: 50.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,63.26l-.37,0h-1.09l-4.19,0-15.73.06-54.94.1.23-.22c0,15.44,0,32.54,0,50.51h0l-.24-.24,76.32,0-.19.19c0-15.37.08-28,.1-36.75,0-4.38,0-7.81.05-10.16,0-1.16,0-2,0-2.67s0-.93,0-.93,0,.3,0,.89,0,1.49,0,2.63c0,2.34,0,5.76.05,10.12,0,8.81.06,21.45.1,36.87v.2h-.19l-76.32,0h-.24v-.25h0c0-18,0-35.07,0-50.51V63h.22l55.09.11,15.67.06,4.15,0h1.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.74,54.72a8.59,8.59,0,0,1,1.68,1.09c1,.72,2.35,1.74,3.82,2.91S372,61,372.9,61.84a7.4,7.4,0,0,1,1.39,1.42,67.22,67.22,0,0,1-5.35-4.16A54.82,54.82,0,0,1,363.74,54.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.16,54.91A45.74,45.74,0,0,1,456,59.28a46.35,46.35,0,0,1-5.43,4,48.43,48.43,0,0,1,5.13-4.36A47.67,47.67,0,0,1,461.16,54.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.09,122.13l-10.87-8.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.22,113.33a51.13,51.13,0,0,1,5.59,4.22,52.38,52.38,0,0,1,5.28,4.58,48.73,48.73,0,0,1-5.59-4.21A53,53,0,0,1,450.22,113.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.74,122.12a47.39,47.39,0,0,1,5.08-4.31,44.45,44.45,0,0,1,5.37-3.94,47.39,47.39,0,0,1-5.08,4.31A44.45,44.45,0,0,1,363.74,122.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.34,
    y: 63.45,
    width: 16.91,
    height: 48.02,
    transform: "translate(326.34 501.26) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6,341.35a35.42,35.42,0,0,0-15.13-5.21c-2.47-.25-5.18-.18-7.16,1.32a1.49,1.49,0,0,0-.74,1.31,1.61,1.61,0,0,0,.7.89c6.16,4.7,15.47,5.29,22.33,1.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21,340.92a73.36,73.36,0,0,1-9.77-8.59A24.83,24.83,0,0,1,368.31,321a4.61,4.61,0,0,1,.48-3.79c7.79,6.08,13.91,14,15.42,23.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,341.29a35.23,35.23,0,0,1,.18-12.83,17.34,17.34,0,0,1,6.83-10.58c1.35,3.14.77,6.77-.18,10.06a48.46,48.46,0,0,1-6.78,14.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.15,355c-4.63.56-8.67,3-12.13,6.14A22.93,22.93,0,0,0,373.08,373c4.55-.28,8.4-3.49,11.2-7.08s4.74-7.54,7.81-10.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81,357.16a29.91,29.91,0,0,1,3.46-28.3c2.64,9.39,1.67,20-3.46,28.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,369.18a21.61,21.61,0,0,0-20.69,11.91,1.59,1.59,0,0,0-.14,1.62,1.51,1.51,0,0,0,1.37.4c4.08-.26,7.69-2.71,10.68-5.51s5.58-6,8.87-8.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.58,368.52a38.52,38.52,0,0,1-.39-21.52c.76-2.77,2-5.69,4.6-7a.88.88,0,0,1,.7-.12.89.89,0,0,1,.44.51,13,13,0,0,1,1.09,6.18,39,39,0,0,1-1,6.25c-.81,3.82-1.24,7.93-3.33,11.22a22.61,22.61,0,0,0-1.34,2.47c-.39.83-.39,1.13-.76,1.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.28,372.5c-2-7.52.12-16.65,4.87-22.82.35-.45.81-.94,1.38-.89.87.08,1.1,1.25,1.06,2.12a41.19,41.19,0,0,1-7.31,21.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.69,374.15c9.15,2.38,19.63.06,27.24-5.54a22,22,0,0,0-14.75-1.81c-4.92,1.12-9.42,3.33-12.49,7.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.72,369.14c5.12-8.35,14.94-13.8,24.72-14.3-1.12,4-4.39,7.07-8.08,8.94s-7.81,2.68-11.87,3.47c-1.58.31-3.74.65-4.77,1.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.79,344.82A71.47,71.47,0,0,0,434,330.34c.38-4.93-.32-10.08-2.88-14.32-4.78,9.26-5.27,20.07-.42,29.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.9,336.68c5.59-10.17,17-18.29,28.55-19.43-4.45,11.1-16.6,19.67-28.55,19.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.38,338.67c8.34,1.27,15.45,6.6,23.25,9.83a10.44,10.44,0,0,0,5.25,1,4.12,4.12,0,0,0,2.58-7.28,11.21,11.21,0,0,0-3.82-2.31c-8.49-3.54-17.6-3.63-26.54-1.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.55,344.52c1.89.54,2.53,1.52,4,2.8a43.49,43.49,0,0,0,17.63,9.05c.67.17,1.56.24,1.89-.37s-.08-1.18-.46-1.65A24.3,24.3,0,0,0,451,347.12c-4.07-1.51-7.59-3.34-12.45-2.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,309.18a33.35,33.35,0,0,0,25.58,8.71,1.74,1.74,0,0,0,1.16-.42c.65-.7-.12-1.78-.87-2.37-7.52-5.86-16.63-8.29-25.87-5.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,306.82a35.69,35.69,0,0,1,31.92-5.27,25.33,25.33,0,0,1-15.21,6.68,48.34,48.34,0,0,1-16.71-1.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,290.58c-.73-7.51-.26-13.43-.78-21,0-.6-.17-1.33-.73-1.55-.79-.3-1.44.67-1.7,1.47a24,24,0,0,0,3.2,20.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.45,291.41a44.19,44.19,0,0,0,12.44-12.09c2.45-3.36,4.52-7.38,4-11.51a11.93,11.93,0,0,0-9,4.46,25,25,0,0,0-4.58,9.2c-1,3.3-1.69,6.69-2.86,9.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.67,288a100.43,100.43,0,0,0,30.6-18c-3.66-1.47-7.84-.59-11.5.89-8.34,3.37-15.17,9.06-19.26,17.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.89,295.52c5.65.61,11.39,1,17,.08s10.71-3.11,15.86-5.27a1.88,1.88,0,0,0,1.08-.82,1.24,1.24,0,0,0-.39-1.36,3.29,3.29,0,0,0-1.35-.63c-5.6-1.57-11.64-.83-17.14,1a79.06,79.06,0,0,0-15.05,7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64,309.44c-3.86-7.78-3.61-16.86-.28-24.87,2.34,3.57,2.63,8.11,2.2,12.36s-1.72,8.63-1.8,12.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.24,301.68a34.65,34.65,0,0,0-25.78,11c4.8.75,9.75-.49,14.12-2.62a71.29,71.29,0,0,0,12.09-8.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,298.21c-4.71-.38-9.24-1-13.76.43a16.46,16.46,0,0,0-10.49,8.89,24.81,24.81,0,0,0,12.9-2.44,73,73,0,0,0,11.35-6.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.21,298.37c-4.23-2.77-8.58-5.6-13.51-6.75s-10.64-.3-14.08,3.42c4,2.34,8.83,2.62,13.46,2.61s10.3,0,14.66,1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.24,298.6c-7.24-7.11-10-19.88-7.07-29.6a45.08,45.08,0,0,1,7.07,29.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.15,278.45c1.36-3.17,2.32-6.5,3.55-9.73a27.86,27.86,0,0,1,5.06-9,13.32,13.32,0,0,1,9-4.64,36.1,36.1,0,0,1-17.4,23.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54,282.65c-2.26-3.11-4.87-7.33-7.93-9.65s-7.05-3.73-10.79-2.84a25.14,25.14,0,0,0,18.72,12.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.26,278.71a53.69,53.69,0,0,1-3.57-11.56,18.07,18.07,0,0,1,1.81-11.76c4,7.51,5.26,15.57,2,23.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,255.39c2.25-7.45,9.07-12.93,16.43-15.45a6.22,6.22,0,0,1,2.88-.43,2.51,2.51,0,0,1,2.13,1.77c.27,1.27-.78,2.41-1.76,3.25a56.07,56.07,0,0,1-19.68,10.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.26,249.3c.29-4.8.59-9.67,2.15-14.22s4.57-8.82,8.95-10.81c.75,4.85-1.39,9.67-4,13.85s-5.69,8.11-7.24,12.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.15,252.6c-1.86-5.42-2.06-12.32-5.31-17-2.27-3.31-5.91-5.56-7.86-9.06a13.77,13.77,0,0,0,.45,10.28,29.8,29.8,0,0,0,6,8.61c2.4,2.56,4.46,4.5,6.7,7.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,412.42c-.14,0-.27-36.2-.28-80.85s.1-80.86.25-80.86.27,36.2.28,80.86S417.33,412.42,417.18,412.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.82,304a9.09,9.09,0,0,1-1.36.51l-3.75,1.26c-3.16,1.08-7.5,2.64-12.2,4.57s-9.06,3.62-11.57,5.79a8.46,8.46,0,0,0-2.32,3.07c-.36.85-.43,1.37-.47,1.37s0-.14,0-.38a5.83,5.83,0,0,1,.27-1.06,8.12,8.12,0,0,1,2.27-3.28,20.21,20.21,0,0,1,5-3.11c2-.94,4.24-1.92,6.6-2.89,4.72-1.93,9.09-3.44,12.29-4.43,1.59-.5,2.9-.86,3.8-1.11A7.36,7.36,0,0,1,448.82,304Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.19,278.51a2.54,2.54,0,0,1-.38.4L457.65,280l-4.34,3.94L438.87,296.8c-5.63,5-10.5,9.8-13.87,13.41-1.69,1.8-3,3.3-3.93,4.34-.43.48-.77.88-1.05,1.2s-.38.41-.39.39.09-.17.31-.46.54-.72,1-1.26c.86-1.09,2.15-2.62,3.81-4.46a183,183,0,0,1,13.81-13.55c5.65-5,10.8-9.5,14.53-12.74l4.45-3.82,1.23-1C459,278.6,459.18,278.49,459.19,278.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.79,301.9c-.15-.07,1-2.79,2.2-6.22s1.75-6.34,1.9-6.32a21.46,21.46,0,0,1-1.4,6.48,42.16,42.16,0,0,1-1.75,4.35A7,7,0,0,1,432.79,301.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.22,323.81a6.42,6.42,0,0,1-.87-1L414.12,320c-1.87-2.42-4.45-5.75-7.34-9.4s-5.56-6.92-7.49-9.29L397,298.45a7,7,0,0,1-.79-1.08,7,7,0,0,1,.94.95c.58.62,1.4,1.55,2.4,2.7,2,2.31,4.72,5.55,7.62,9.21s5.43,7,7.23,9.5c.9,1.23,1.61,2.24,2.09,2.95A8.16,8.16,0,0,1,417.22,323.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.28,314.9a12.66,12.66,0,0,1-2.91-5.44,15.85,15.85,0,0,1-.66-5.48l.23,0c-.1.42-.17.64-.22.63s0-.24,0-.67l.23,0a24.89,24.89,0,0,0,.92,5.33A40.35,40.35,0,0,0,410.28,314.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.32,303.64a8.87,8.87,0,0,0-2-1.18,13.47,13.47,0,0,0-5.63-.45,34.38,34.38,0,0,0-5.67.92,18.55,18.55,0,0,1-2.34.56,7.79,7.79,0,0,1,2.24-.92,25.9,25.9,0,0,1,5.73-1.08,12.19,12.19,0,0,1,5.81.63A3.5,3.5,0,0,1,401.32,303.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.2,300.91c0,.08-1.18-.48-3.11-1.13a31.55,31.55,0,0,0-7.75-1.6,32.22,32.22,0,0,0-7.91.4c-2,.36-3.22.74-3.25.65a2.65,2.65,0,0,1,.83-.35,20.15,20.15,0,0,1,2.34-.66,27.68,27.68,0,0,1,15.87,1.21,19.83,19.83,0,0,1,2.22,1A2.9,2.9,0,0,1,399.2,300.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.15,289.36a63.36,63.36,0,0,1-2.27-7.87,64.79,64.79,0,0,1-1.76-8,66,66,0,0,1,2.27,7.88A64.87,64.87,0,0,1,417.15,289.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.29,289.36a39.25,39.25,0,0,0-2.51-4.71,20.88,20.88,0,0,0-3.7-3.82,3.52,3.52,0,0,1,1.43.74,11.77,11.77,0,0,1,2.7,2.78A10.45,10.45,0,0,1,417.29,289.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,393.12c-.05,0-.16-.87-.57-2.41a34,34,0,0,0-2.42-6.26c-2.5-5.11-7.05-11.6-12.83-18.09-2.87-3.27-5.65-6.36-8-9.32a64.57,64.57,0,0,1-5.72-8.25,38.85,38.85,0,0,1-2.89-6.13c-.27-.76-.46-1.34-.57-1.75a2.46,2.46,0,0,1-.15-.63c.05,0,.31.83.91,2.31a43.31,43.31,0,0,0,3,6,67,67,0,0,0,5.78,8.14c2.37,2.93,5.15,6,8,9.28,5.8,6.51,10.34,13.07,12.78,18.27a31.62,31.62,0,0,1,2.28,6.38,16.84,16.84,0,0,1,.32,1.81A2.81,2.81,0,0,1,417.18,393.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.77,360.83a11.71,11.71,0,0,1-1.5.84,32.38,32.38,0,0,0-3.88,2.57,44.78,44.78,0,0,0-5.11,4.66c-1.79,1.89-3.63,4.09-5.52,6.44-3.76,4.73-7.28,8.91-9.39,12.24-1.07,1.66-1.85,3.06-2.36,4a12.46,12.46,0,0,1-.83,1.51,1.73,1.73,0,0,1,.14-.42c.11-.27.26-.68.5-1.18a40.39,40.39,0,0,1,2.23-4.13c2.05-3.42,5.55-7.66,9.3-12.38,1.89-2.35,3.76-4.56,5.58-6.45a42.44,42.44,0,0,1,5.23-4.61,26.92,26.92,0,0,1,4-2.46c.49-.25.9-.4,1.17-.51A1.46,1.46,0,0,1,445.77,360.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.33,371.31a23.49,23.49,0,0,1-3.17.46,41.79,41.79,0,0,0-7.51,1.48,22.47,22.47,0,0,0-6.72,3.53c-1.55,1.19-2.28,2.18-2.36,2.13a2.61,2.61,0,0,1,.47-.73,11.91,11.91,0,0,1,1.65-1.69,20.43,20.43,0,0,1,6.8-3.74,34.15,34.15,0,0,1,7.64-1.35A17.43,17.43,0,0,1,446.33,371.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.5,377.76c-.17-.1,1.26-2.28,2.37-5.21s1.28-5.55,1.47-5.52a5.34,5.34,0,0,1-.06,1.7,18,18,0,0,1-.92,4,18.85,18.85,0,0,1-1.84,3.67A5.28,5.28,0,0,1,427.5,377.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,332.71a2.13,2.13,0,0,1-.51.27l-1.49.67c-.65.28-1.44.64-2.33,1.11s-1.94.94-3,1.59l-1.72,1c-.6.35-1.2.75-1.83,1.15-1.27.77-2.55,1.72-3.91,2.7a67.37,67.37,0,0,0-15.06,15.58c-.93,1.4-1.83,2.7-2.56,4-.37.65-.76,1.25-1.09,1.86l-.92,1.77c-.61,1.1-1.05,2.16-1.49,3.07s-.76,1.71-1,2.37-.46,1.12-.62,1.51a1.93,1.93,0,0,1-.26.52,2.85,2.85,0,0,1,.16-.55c.14-.41.31-.92.53-1.55s.53-1.49.95-2.41.82-2,1.42-3.13l.9-1.79c.31-.62.7-1.23,1.06-1.89.72-1.31,1.62-2.64,2.54-4.05a64.33,64.33,0,0,1,15.18-15.7c1.38-1,2.67-1.91,4-2.68.64-.39,1.24-.79,1.85-1.13l1.76-1c1.1-.63,2.16-1.09,3.07-1.53s1.72-.77,2.38-1l1.53-.59A2.1,2.1,0,0,1,455,332.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,347.87a3.68,3.68,0,0,1,1.25-1.85,7.85,7.85,0,0,1,5-1.93,14,14,0,0,1,5.28,1,7.44,7.44,0,0,1,2,1,12.34,12.34,0,0,1-2.12-.62,15.87,15.87,0,0,0-5.13-.85,8.12,8.12,0,0,0-4.79,1.68A15,15,0,0,0,432.4,347.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,351.36a19,19,0,0,0,1.43-4.63,19.21,19.21,0,0,0-.32-4.84,3.19,3.19,0,0,1,.58,1.35,9.58,9.58,0,0,1-.81,6.94C429.46,351,429.07,351.39,429,351.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.18,398.31c.78,13.84,4.95,27.91,11.36,42.13h27.89c6.11-14.08,10-28.13,10.68-42.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.59,420.7c0,.14-9.18.26-20.5.26s-20.51-.12-20.51-.26,9.18-.26,20.51-.26S437.59,420.55,437.59,420.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,425.71c0,.14-8.61.26-19.22.26s-19.23-.12-19.23-.26,8.61-.26,19.23-.26S437,425.57,437,425.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,407.39a79.52,79.52,0,0,1,0,12.85,79.52,79.52,0,0,1,0-12.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.93,407.39a85.3,85.3,0,0,1,0,13.31,85.3,85.3,0,0,1,0-13.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,407.28a88.66,88.66,0,0,1,0,13.57,88.66,88.66,0,0,1,0-13.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.23,407.39c0,.15-10.77.27-24.05.27s-24.05-.12-24.05-.27,10.76-.26,24.05-.26S441.23,407.25,441.23,407.39Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.73,446c0,.14-96.84.26-216.28.26s-216.3-.12-216.3-.26,96.82-.26,216.3-.26S465.73,445.85,465.73,446Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.14,37l-28.7,0a7.14,7.14,0,0,0-7,7.31v5.23a7.14,7.14,0,0,1-7,7.31l-56,0a7.15,7.15,0,0,1-7-7.31V44.27a7.15,7.15,0,0,0-7-7.32H195.5l-25.12,0a22.62,22.62,0,0,0-22.6,22.67l-.07,363.62a22.64,22.64,0,0,0,22.58,22.68l147.76.09a22.62,22.62,0,0,0,22.6-22.67l.07-363.63A22.63,22.63,0,0,0,318.14,37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,37s.27,0,.78,0a16.94,16.94,0,0,1,2.29.18,21.33,21.33,0,0,1,8.49,3,22,22,0,0,1,5.15,4.2,22.6,22.6,0,0,1,4.28,6.78,23.45,23.45,0,0,1,1.68,9.19c0,3.34,0,6.9,0,10.67,0,30.17,0,73.83.06,127.77s0,118.18,0,189.5v33.94c0,1.14-.07,2.31-.12,3.47a25,25,0,0,1-.65,3.43,23,23,0,0,1-7.37,11.72,24.56,24.56,0,0,1-6,3.68,23.06,23.06,0,0,1-6.91,1.62l-1.79.09H276.73l-59.19,0-30.27,0H172a23.66,23.66,0,0,1-14.7-4.1,23.1,23.1,0,0,1-8.9-12.4,25.12,25.12,0,0,1-.93-7.65v-7.63q0-15.25,0-30.29,0-30.06,0-59.2c0-38.82,0-76.26,0-111.92s0-69.56,0-101.28q0-23.79,0-45.9V60.3c0-.91.07-1.83.1-2.74s.25-1.81.4-2.7a23.51,23.51,0,0,1,4.6-9.66A22.9,22.9,0,0,1,171,36.75l19.74,0h14.15a7.25,7.25,0,0,1,7.34,4.65,8.12,8.12,0,0,1,.5,2.22c.06.77,0,1.49,0,2.23,0,1.47,0,3,0,4.38a7.3,7.3,0,0,0,1.57,3.86,6.81,6.81,0,0,0,3.41,2.28,15.71,15.71,0,0,0,4.12.26h8.18l29.86,0,13.16,0c1,0,2.09,0,3.09,0a6.49,6.49,0,0,0,2.79-1,7.18,7.18,0,0,0,3.22-4.55,11.55,11.55,0,0,0,.2-2.75V45.74a16.57,16.57,0,0,1,.11-2.64,7.28,7.28,0,0,1,.82-2.43,7.17,7.17,0,0,1,3.56-3.24,10.86,10.86,0,0,1,4.48-.5L306,37l9,0,3.07,0s-1,0-3.07,0l-9,0-14.69,0a10.81,10.81,0,0,0-4.42.51,7,7,0,0,0-3.47,3.17,7.36,7.36,0,0,0-.79,2.37,17.27,17.27,0,0,0-.1,2.61v2.71a12,12,0,0,1-.19,2.79,7.42,7.42,0,0,1-3.3,4.69,6.77,6.77,0,0,1-2.89,1c-1,.07-2.06,0-3.11,0H219.79a7.57,7.57,0,0,1-2.12-.27,7.17,7.17,0,0,1-3.57-2.38,7.75,7.75,0,0,1-1.65-4c-.08-1.48,0-2.92,0-4.41,0-.73,0-1.48,0-2.2a7.42,7.42,0,0,0-.49-2.13,6.9,6.9,0,0,0-7-4.43H171a22.55,22.55,0,0,0-18,8.33,23.23,23.23,0,0,0-4.52,9.5c-.14.88-.3,1.76-.38,2.65s-.13,1.79-.1,2.71v51.39c0,31.72,0,65.61,0,101.28V324.89q0,29.12,0,59.2,0,15,0,30.29V422a24.57,24.57,0,0,0,.91,7.5,22.54,22.54,0,0,0,8.7,12.12,23.09,23.09,0,0,0,14.4,4h15.29l30.27,0,59.19,0,28.84,0H318l1.75-.09a22.38,22.38,0,0,0,6.76-1.59,23.48,23.48,0,0,0,5.91-3.59A22.35,22.35,0,0,0,339.65,429a23.85,23.85,0,0,0,.64-3.35c0-1.14.14-2.27.12-3.42v-6.87q0-13.69,0-27.07c0-71.32.06-135.55.09-189.5s.08-97.6.11-127.77c0-3.77,0-7.33,0-10.67A23.41,23.41,0,0,0,339,51.21a22.69,22.69,0,0,0-4.24-6.74,21.63,21.63,0,0,0-5.11-4.2,21.39,21.39,0,0,0-8.43-3,18.14,18.14,0,0,0-2.29-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 300.58,
    width: 147.7,
    height: 32.2,
    rx: 5.77,
    style: {
      fill: "#FF725E"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.48,135.89l1.17-2.61a8.78,8.78,0,0,0,4.93,1.56c2,0,2.88-.68,2.88-1.6,0-2.79-8.68-.87-8.68-6.42,0-2.54,2.05-4.65,6.29-4.65a10.09,10.09,0,0,1,5.19,1.32l-1.07,2.63a8.46,8.46,0,0,0-4.14-1.18c-2.05,0-2.84.77-2.84,1.71,0,2.75,8.68.85,8.68,6.34,0,2.49-2.06,4.63-6.33,4.63A10.66,10.66,0,0,1,207.48,135.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.62,122.43a1.9,1.9,0,0,1,2.07-1.86,1.87,1.87,0,0,1,2.07,1.79,2.08,2.08,0,0,1-4.14.07Zm.41,3.45h3.32v11.48H222Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.29,125.88v9.56c0,4.27-2.31,6.23-6.45,6.23a9.44,9.44,0,0,1-5.63-1.58l1.32-2.39a6.9,6.9,0,0,0,4.06,1.3c2.34,0,3.37-1.06,3.37-3.13v-.49a4.74,4.74,0,0,1-3.63,1.42,5.55,5.55,0,1,1,0-11.09,4.64,4.64,0,0,1,3.8,1.64v-1.47ZM237,131.26a3,3,0,1,0-3,2.81A2.79,2.79,0,0,0,237,131.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.11,130.79v6.57h-3.33V131.3c0-1.85-.85-2.71-2.32-2.71s-2.76,1-2.76,3.09v5.68h-3.32V125.88h3.17v1.35a5,5,0,0,1,3.8-1.52C253.06,125.71,255.11,127.29,255.11,130.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.75,122.43a1.9,1.9,0,0,1,2.07-1.86,1.86,1.86,0,0,1,2.06,1.79,2.07,2.07,0,0,1-4.13.07Zm.4,3.45h3.33v11.48h-3.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.3,130.79v6.57H279V131.3c0-1.85-.86-2.71-2.33-2.71s-2.75,1-2.75,3.09v5.68h-3.33V125.88h3.18v1.35a5,5,0,0,1,3.8-1.52C280.26,125.71,282.3,127.29,282.3,130.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,186.57v.54h-4.18V181.2h4.06v.54h-3.44v2.1h3.06v.54h-3.06v2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.26,184.56h2.21v.53h-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,184.54v2.57h-.6V184.6c0-.94-.47-1.43-1.27-1.43a1.44,1.44,0,0,0-1.49,1.61v2.33h-.6V184.6c0-.94-.47-1.43-1.28-1.43a1.44,1.44,0,0,0-1.49,1.61v2.33h-.6v-4.44h.57v.81a1.82,1.82,0,0,1,1.63-.85,1.6,1.6,0,0,1,1.58.94,2,2,0,0,1,1.76-.94A1.68,1.68,0,0,1,185.15,184.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14,184.36v2.75h-.57v-.69a1.67,1.67,0,0,1-1.53.74c-1,0-1.62-.53-1.62-1.3s.43-1.26,1.71-1.26h1.41v-.27c0-.76-.43-1.17-1.26-1.17a2.29,2.29,0,0,0-1.48.52l-.27-.45a2.84,2.84,0,0,1,1.81-.6A1.58,1.58,0,0,1,190.14,184.36Zm-.6,1.42v-.73h-1.39c-.86,0-1.14.34-1.14.8s.41.83,1.12.83A1.41,1.41,0,0,0,189.54,185.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,181.26a.44.44,0,1,1,.44.44A.43.43,0,0,1,191.64,181.26Zm.13,1.41h.61v4.44h-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.05,180.84h.6v6.27h-.6Z",
    style: {
      fill: "#263238"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.6,241.48c0,1.26-.91,2-2.42,2h-1.59v1.87H167v-5.92h2.21C170.69,239.45,171.6,240.22,171.6,241.48Zm-.62,0c0-.94-.63-1.48-1.81-1.48h-1.58V243h1.58C170.35,243,171,242.41,171,241.48Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.14,242.62v2.75h-.57v-.69a1.66,1.66,0,0,1-1.53.73c-1,0-1.63-.52-1.63-1.29s.44-1.26,1.72-1.26h1.41v-.27c0-.76-.43-1.17-1.26-1.17a2.29,2.29,0,0,0-1.48.52l-.27-.45a2.84,2.84,0,0,1,1.81-.6A1.58,1.58,0,0,1,176.14,242.62Zm-.6,1.42v-.73h-1.39c-.87,0-1.15.34-1.15.79s.42.84,1.13.84A1.42,1.42,0,0,0,175.54,244Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.16,244.86l.27-.47a2.65,2.65,0,0,0,1.58.5c.84,0,1.19-.29,1.19-.73,0-1.16-2.88-.24-2.88-2,0-.73.62-1.27,1.75-1.27a3,3,0,0,1,1.58.42l-.27.48a2.26,2.26,0,0,0-1.31-.38c-.8,0-1.15.31-1.15.73,0,1.2,2.88.3,2.88,2,0,.77-.68,1.26-1.84,1.26A2.9,2.9,0,0,1,177.16,244.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.29,244.86l.27-.47a2.65,2.65,0,0,0,1.58.5c.85,0,1.19-.29,1.19-.73,0-1.16-2.88-.24-2.88-2,0-.73.63-1.27,1.76-1.27a3,3,0,0,1,1.57.42l-.26.48a2.3,2.3,0,0,0-1.31-.38c-.81,0-1.16.31-1.16.73,0,1.2,2.88.3,2.88,2,0,.77-.67,1.26-1.83,1.26A2.91,2.91,0,0,1,181.29,244.86Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.48,240.93l-1.68,4.44h-.57l-1.4-3.64-1.4,3.64h-.57l-1.67-4.44h.57l1.4,3.77,1.43-3.77h.51l1.42,3.77,1.41-3.77Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.81,243.15a2.27,2.27,0,1,1,2.27,2.26A2.19,2.19,0,0,1,192.81,243.15Zm3.92,0a1.66,1.66,0,1,0-1.65,1.73A1.62,1.62,0,0,0,196.73,243.15Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.8,240.89v.58h-.14a1.44,1.44,0,0,0-1.5,1.64v2.26h-.6v-4.44h.58v.87A1.65,1.65,0,0,1,200.8,240.89Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.9,239.1v6.27h-.58v-.88a1.92,1.92,0,0,1-1.71.92,2.26,2.26,0,0,1,0-4.52,2,2,0,0,1,1.69.88V239.1Zm-.59,4.05a1.66,1.66,0,1,0-1.65,1.73A1.62,1.62,0,0,0,205.31,243.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.56,319.21l.59-1.31a4.39,4.39,0,0,0,2.47.78c1,0,1.44-.34,1.44-.8,0-1.4-4.35-.44-4.35-3.22,0-1.27,1-2.33,3.15-2.33a5,5,0,0,1,2.6.66l-.53,1.32a4.2,4.2,0,0,0-2.08-.59c-1,0-1.42.38-1.42.85,0,1.38,4.35.43,4.35,3.18,0,1.25-1,2.32-3.17,2.32A5.35,5.35,0,0,1,220.56,319.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.65,312.46a1,1,0,0,1,1-.93.93.93,0,0,1,1,.89,1,1,0,0,1-2.07,0Zm.2,1.73h1.67v5.75h-1.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,316.65v3.29h-1.66v-3c0-.94-.43-1.36-1.17-1.36s-1.38.49-1.38,1.55v2.84h-1.67v-5.75h1.6v.67a2.51,2.51,0,0,1,1.9-.76A2.25,2.25,0,0,1,237,316.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.46,314.19V319c0,2.14-1.15,3.12-3.23,3.12a4.68,4.68,0,0,1-2.82-.79l.66-1.2a3.42,3.42,0,0,0,2,.66c1.18,0,1.69-.54,1.69-1.58V319a2.36,2.36,0,0,1-1.81.72,2.79,2.79,0,1,1,0-5.57,2.3,2.3,0,0,1,1.9.83v-.74Zm-1.64,2.69a1.52,1.52,0,1,0-1.51,1.42A1.4,1.4,0,0,0,242.82,316.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,312.46a1,1,0,0,1,1-.93.93.93,0,0,1,1,.89,1,1,0,0,1-2.07,0Zm.2,1.73h1.67v5.75H249Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.14,316.65v3.29h-1.66v-3c0-.94-.43-1.36-1.17-1.36s-1.38.49-1.38,1.55v2.84h-1.67v-5.75h1.59v.67a2.54,2.54,0,0,1,1.91-.76A2.25,2.25,0,0,1,258.14,316.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 193.52,
    width: 147.7,
    height: 31.95,
    rx: 7.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,225.47l.22,0c.15,0,.38,0,.67-.06a6.76,6.76,0,0,0,2.46-.83,7,7,0,0,0,2.86-3,6.83,6.83,0,0,0,.68-2.59c0-1,0-2,0-3.1,0-4.39,0-9.78-.08-16a6.94,6.94,0,0,0-2-4.19A6.83,6.83,0,0,0,307,193.7h-11.2L173,193.78a6.78,6.78,0,0,0-6.46,4.77,15.83,15.83,0,0,0-.3,4.32v15.24a7.09,7.09,0,0,0,.23,2.06,6.72,6.72,0,0,0,2.14,3.42,6.8,6.8,0,0,0,3.67,1.59c1.35.07,2.78,0,4.16,0h24.19l55.19.05,37.21.09,10.12,0,2.63,0,.9,0-.9,0-2.63,0-10.12,0-37.21.08-55.19.06H176.46c-1.4,0-2.76,0-4.21,0A7.24,7.24,0,0,1,166,220.3a7.79,7.79,0,0,1-.24-2.19V200.66a8.28,8.28,0,0,1,.32-2.26,7.31,7.31,0,0,1,7-5.14l122.77.07,11.21,0a7.14,7.14,0,0,1,6.81,6.43c.06,6.27,0,11.62,0,16,0,1.1,0,2.13,0,3.11a7.05,7.05,0,0,1-.72,2.65,6.94,6.94,0,0,1-2.95,3.06,6.58,6.58,0,0,1-2.51.79A6,6,0,0,1,306.7,225.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 251.18,
    width: 147.7,
    height: 31.95,
    rx: 7.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,283.13l.22,0a5.85,5.85,0,0,0,.67-.07,6.9,6.9,0,0,0,2.46-.82,7.07,7.07,0,0,0,2.86-3,6.83,6.83,0,0,0,.68-2.59c0-1,0-2,0-3.11,0-4.38,0-9.78-.08-16a6.88,6.88,0,0,0-2-4.18,6.79,6.79,0,0,0-4.51-1.95h-11.2L173,251.44a6.79,6.79,0,0,0-6.46,4.78,15.73,15.73,0,0,0-.3,4.31v15.24a7,7,0,0,0,.23,2.06,6.72,6.72,0,0,0,2.14,3.42,6.8,6.8,0,0,0,3.67,1.59c1.35.08,2.78,0,4.16,0h24.19l55.19.06,37.21.08,10.12.05,2.63,0,.9,0-.9,0-2.63,0-10.12.05-37.21.09-55.19.05H176.46c-1.4,0-2.76.05-4.21,0A7.24,7.24,0,0,1,166,278a7.75,7.75,0,0,1-.24-2.19V258.33a8.35,8.35,0,0,1,.32-2.27,7.31,7.31,0,0,1,7-5.14l122.77.07L307,251a7.1,7.1,0,0,1,4.72,2.06,7.19,7.19,0,0,1,2.09,4.37c.06,6.27,0,11.62,0,16,0,1.1,0,2.13,0,3.12a7.09,7.09,0,0,1-3.67,5.71,6.71,6.71,0,0,1-2.51.78A6,6,0,0,1,306.7,283.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.93,400.81s.31,0,.9-.1a5.79,5.79,0,0,0,2.4-1,5.68,5.68,0,0,0,2.27-3.49,14,14,0,0,0,.11-2.72c0-1,0-2,0-3.14,0-4.43,0-9.84-.05-16.12a5.63,5.63,0,0,0-2-4.15,5.47,5.47,0,0,0-2.2-1.12,9.45,9.45,0,0,0-2.57-.18l-11.3,0-123.69.07a5.55,5.55,0,0,0-3.88,1.6,5.45,5.45,0,0,0-1.63,3.85q0,4.47,0,8.88v10.93a9.55,9.55,0,0,0,.13,2.09,5.49,5.49,0,0,0,2.22,3.33,5.58,5.58,0,0,0,1.84.84,8.12,8.12,0,0,0,2.05.17h28.59l55.61.06,37.49.08,10.19.05,2.65,0,.9,0-.9,0-2.65,0-10.19.05L256.7,401l-55.61.06H172.5a8.06,8.06,0,0,1-2.17-.18,5.8,5.8,0,0,1-2-.91,6,6,0,0,1-2.43-3.64,9.72,9.72,0,0,1-.14-2.2V374.31a6,6,0,0,1,6-6l123.69.08,11.3,0a9.46,9.46,0,0,1,2.65.2,5.83,5.83,0,0,1,2.32,1.19,6,6,0,0,1,2.1,4.38c0,6.29,0,11.7,0,16.13,0,1.11,0,2.15,0,3.14a14.42,14.42,0,0,1-.13,2.75,5.85,5.85,0,0,1-2.37,3.55,5.77,5.77,0,0,1-2.45,1A4.46,4.46,0,0,1,307.93,400.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.71,384.71c0,.14-14.95.26-33.39.26s-33.38-.12-33.38-.26,14.94-.26,33.38-.26S272.71,384.57,272.71,384.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.41,
    cy: 101.15,
    r: 12.52,
    transform: "translate(0.35 203.16) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,110.65a8,8,0,0,0-8.09-7.11,8.22,8.22,0,0,0-8.09,7.14,11.09,11.09,0,0,0,8.09,3A11.47,11.47,0,0,0,253.5,110.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.41,
    cy: 99.49,
    r: 4.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,110.22a9.89,9.89,0,0,0-.76-2.31,7.78,7.78,0,0,0-1.77-2.18,9.72,9.72,0,0,0-3.2-1.79l-.25-.09.23-.12a4.88,4.88,0,0,0,1.95-2,4.79,4.79,0,0,0-1-5.83,4.74,4.74,0,0,0-6.36,0,4.65,4.65,0,0,0-1.54,2.84,4.73,4.73,0,0,0,.5,3,4.62,4.62,0,0,0,.86,1.14,5.65,5.65,0,0,0,1.08.83l.22.14-.25.07a7.5,7.5,0,0,0-3.2,1.77,7.93,7.93,0,0,0-1.67,2.26,8.68,8.68,0,0,0-.66,1.69,4.6,4.6,0,0,0-.12.46.7.7,0,0,1-.05.16s0-.06,0-.17,0-.26.09-.47a8.91,8.91,0,0,1,.61-1.73,8.2,8.2,0,0,1,1.67-2.34,7.55,7.55,0,0,1,3.26-1.85l0,.2a6.24,6.24,0,0,1-1.13-.84,5.42,5.42,0,0,1-.91-1.2,5.07,5.07,0,0,1-.55-3.14,5,5,0,0,1,1.62-3,5.1,5.1,0,0,1,3.37-1.29,5,5,0,0,1,4.41,7.46,5.11,5.11,0,0,1-2.07,2l0-.21a9.91,9.91,0,0,1,3.26,1.87,7.73,7.73,0,0,1,1.76,2.26,6,6,0,0,1,.39,1,3.47,3.47,0,0,1,.18.75l.07.48C253.45,110.17,253.45,110.22,253.44,110.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,101.15a.55.55,0,0,1,0-.2c0-.15,0-.35,0-.6s0-.27,0-.43-.05-.34-.08-.53a8.8,8.8,0,0,0-.27-1.29,12.08,12.08,0,0,0-1.39-3.31,12.41,12.41,0,0,0-3.17-3.52A12.27,12.27,0,0,0,247.69,89a12.47,12.47,0,0,0-6.52.54,13.59,13.59,0,0,0-1.62.72,12.87,12.87,0,0,0-1.51,1,13.35,13.35,0,0,0-1.41,1.2,13.19,13.19,0,0,0-3,4.85,12.45,12.45,0,0,0,0,7.82,12.34,12.34,0,0,0,1.77,3.42,13.94,13.94,0,0,0,1.22,1.43,14.33,14.33,0,0,0,1.4,1.2,15.66,15.66,0,0,0,1.52,1,13.51,13.51,0,0,0,1.62.71,12.58,12.58,0,0,0,6.52.55,12.54,12.54,0,0,0,8.4-5.84,12.08,12.08,0,0,0,1.39-3.31,8.8,8.8,0,0,0,.27-1.29c0-.19.06-.36.08-.52s0-.31,0-.44,0-.45,0-.6a.55.55,0,0,1,0-.2v.8c0,.13,0,.28,0,.44s0,.34-.07.53a8.26,8.26,0,0,1-.24,1.3,11.64,11.64,0,0,1-1.37,3.37,12.24,12.24,0,0,1-3.18,3.6,12.53,12.53,0,0,1-5.31,2.39,12.76,12.76,0,0,1-6.65-.54,13.3,13.3,0,0,1-1.65-.72,13.62,13.62,0,0,1-1.56-1,16.46,16.46,0,0,1-1.43-1.22,14.69,14.69,0,0,1-1.25-1.47,12.44,12.44,0,0,1-1.81-3.49,12.45,12.45,0,0,1,0-8,12.44,12.44,0,0,1,1.81-3.49,14.57,14.57,0,0,1,1.25-1.46A12.73,12.73,0,0,1,237.88,91a11.67,11.67,0,0,1,1.55-1,13.3,13.3,0,0,1,1.65-.72,12.6,12.6,0,0,1,12,1.85,12.52,12.52,0,0,1,3.18,3.6,11.64,11.64,0,0,1,1.37,3.37,8.26,8.26,0,0,1,.24,1.3c0,.19.06.37.07.53s0,.31,0,.44v.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.76,153.22c0,.15-35.17.26-78.54.26s-78.55-.11-78.55-.26,35.16-.26,78.55-.26S322.76,153.08,322.76,153.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.76,350.85c0,.14-35.17.26-78.54.26s-78.55-.12-78.55-.26,35.16-.26,78.55-.26S322.76,350.71,322.76,350.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,266.64l2.23,1.26-.58,1-2.28-1.34,0,2.56h-1.13l0-2.56-2.27,1.34-.59-1,2.26-1.26-2.26-1.24.59-1,2.27,1.33,0-2.54h1.13l0,2.54,2.28-1.33.58,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,266.64,191,267.9l-.59,1-2.27-1.34,0,2.56H187l0-2.56-2.28,1.34-.58-1,2.25-1.26-2.25-1.24.58-1,2.28,1.33,0-2.54h1.13l0,2.54,2.27-1.33.59,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.65,266.64l2.24,1.26-.58,1L196,267.6l0,2.56h-1.13l0-2.56-2.28,1.34-.58-1,2.26-1.26-2.26-1.24.58-1,2.28,1.33,0-2.54h1.13l0,2.54,2.28-1.33.58,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,266.64l2.24,1.26-.58,1-2.28-1.34,0,2.56h-1.13l0-2.56-2.27,1.34-.59-1,2.26-1.26L200,265.4l.59-1,2.27,1.33,0-2.54H204l0,2.54,2.28-1.33.58,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,209.46V212h-.6v-2.52a1.25,1.25,0,0,0-1.34-1.42,1.46,1.46,0,0,0-1.55,1.61V212h-.6V207.6h.57v.82a1.87,1.87,0,0,1,1.69-.86A1.71,1.71,0,0,1,181.3,209.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,209.29V212h-.58v-.69a1.66,1.66,0,0,1-1.53.74c-1,0-1.62-.53-1.62-1.3s.44-1.26,1.71-1.26h1.42v-.27c0-.76-.43-1.17-1.26-1.17a2.25,2.25,0,0,0-1.48.52l-.27-.45a2.8,2.8,0,0,1,1.81-.6A1.58,1.58,0,0,1,186.29,209.29Zm-.6,1.42V210h-1.4c-.86,0-1.14.34-1.14.79s.41.84,1.12.84A1.43,1.43,0,0,0,185.69,210.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,209.46V212h-.6v-2.52c0-.93-.48-1.42-1.28-1.42a1.44,1.44,0,0,0-1.49,1.61V212h-.6v-2.52c0-.93-.47-1.42-1.28-1.42a1.44,1.44,0,0,0-1.49,1.61V212h-.6V207.6h.57v.81a1.82,1.82,0,0,1,1.63-.85,1.62,1.62,0,0,1,1.59.94,1.94,1.94,0,0,1,1.75-.94A1.68,1.68,0,0,1,195.26,209.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.78,210h-3.72a1.63,1.63,0,0,0,1.75,1.54,1.75,1.75,0,0,0,1.36-.58l.34.39a2.35,2.35,0,0,1-4-1.54,2.14,2.14,0,0,1,2.17-2.26,2.12,2.12,0,0,1,2.15,2.26Zm-3.72-.45h3.15a1.58,1.58,0,0,0-3.15,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,209.8c0,1.44-.53,2.29-1.4,2.29a.9.9,0,0,1-.95-.93,1.88,1.88,0,0,1-1.69.93,2.19,2.19,0,0,1,0-4.37,1.89,1.89,0,0,1,1.67.89v-.85h.55V211c0,.47.24.64.52.64.53,0,.87-.65.87-1.79a3.22,3.22,0,0,0-3.48-3.3,3.4,3.4,0,1,0,0,6.79,3.79,3.79,0,0,0,1.62-.37l.14.41a4,4,0,0,1-1.76.39,3.83,3.83,0,1,1,0-7.66A3.66,3.66,0,0,1,209.47,209.8Zm-2.36.1a1.61,1.61,0,1,0-1.61,1.69A1.58,1.58,0,0,0,207.11,209.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,209.46V212h-.6v-2.52c0-.93-.47-1.42-1.28-1.42a1.43,1.43,0,0,0-1.48,1.61V212h-.6v-2.52c0-.93-.48-1.42-1.29-1.42a1.44,1.44,0,0,0-1.49,1.61V212h-.6V207.6h.58v.81a1.81,1.81,0,0,1,1.63-.85,1.6,1.6,0,0,1,1.58.94,2,2,0,0,1,1.76-.94A1.68,1.68,0,0,1,218.08,209.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.07,209.29V212h-.58v-.69a1.66,1.66,0,0,1-1.53.74c-1,0-1.62-.53-1.62-1.3s.44-1.26,1.72-1.26h1.41v-.27c0-.76-.43-1.17-1.26-1.17a2.25,2.25,0,0,0-1.48.52l-.27-.45a2.84,2.84,0,0,1,1.81-.6A1.58,1.58,0,0,1,223.07,209.29Zm-.6,1.42V210h-1.4c-.86,0-1.14.34-1.14.79s.42.84,1.13.84A1.43,1.43,0,0,0,222.47,210.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,206.19a.43.43,0,0,1,.44-.42.43.43,0,1,1,0,.85A.43.43,0,0,1,224.57,206.19Zm.13,1.41h.6V212h-.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,205.77h.6V212H227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,211.62a.45.45,0,0,1,.45-.46.46.46,0,0,1,.45.46.47.47,0,0,1-.45.47A.46.46,0,0,1,228.86,211.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,209.82a2.19,2.19,0,0,1,2.29-2.26,2,2,0,0,1,1.74.88l-.45.31a1.5,1.5,0,0,0-1.29-.66,1.73,1.73,0,0,0,0,3.46,1.49,1.49,0,0,0,1.29-.65l.45.31a2,2,0,0,1-1.74.88A2.2,2.2,0,0,1,230.47,209.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.15,209.82a2.26,2.26,0,1,1,2.26,2.27A2.19,2.19,0,0,1,235.15,209.82Zm3.91,0a1.65,1.65,0,1,0-1.65,1.73A1.62,1.62,0,0,0,239.06,209.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.24,209.46V212h-.6v-2.52c0-.93-.48-1.42-1.28-1.42a1.44,1.44,0,0,0-1.49,1.61V212h-.6v-2.52c0-.93-.47-1.42-1.28-1.42a1.44,1.44,0,0,0-1.49,1.61V212h-.6V207.6h.57v.81a1.82,1.82,0,0,1,1.63-.85,1.62,1.62,0,0,1,1.59.94,1.94,1.94,0,0,1,1.75-.94A1.68,1.68,0,0,1,248.24,209.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,77.79a.45.45,0,0,1-.32-.13l-4.7-4.12a.49.49,0,0,1,0-.75l4.7-3.9a.48.48,0,0,1,.69.06.49.49,0,0,1-.06.7L168,73.18l4.26,3.74a.49.49,0,0,1,.05.7A.52.52,0,0,1,171.89,77.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,73.28a2.51,2.51,0,1,1-2.51-2.51A2.51,2.51,0,0,1,308.28,73.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.52,73.28A2.51,2.51,0,1,1,313,70.77,2.51,2.51,0,0,1,315.52,73.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.76,73.28a2.51,2.51,0,1,1-2.5-2.51A2.51,2.51,0,0,1,322.76,73.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.48,164.81H383.61a9.44,9.44,0,0,0-9.44,9.44v14.9a9.44,9.44,0,0,0,9.44,9.44h.62v8.51l9.59-8.51h49.66a9.44,9.44,0,0,0,9.44-9.44v-14.9A9.44,9.44,0,0,0,443.48,164.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.48,164.81H444a8.63,8.63,0,0,1,1.38.13c.3.06.64.15,1,.24a10.15,10.15,0,0,1,1.16.45,9.3,9.3,0,0,1,2.58,1.74,9.7,9.7,0,0,1,2.23,3.2,10.88,10.88,0,0,1,.75,4.58c0,3.33,0,7.13,0,11.35,0,1.06,0,2.13,0,3.25a9.64,9.64,0,0,1-6,8.34,10.14,10.14,0,0,1-3.8.71h-3.95l-8.26,0-37.25,0,.17-.07-9.58,8.52-.44.38v-9.09l.26.26a10.16,10.16,0,0,1-5.37-1.25,9.89,9.89,0,0,1-3.81-3.89,10.61,10.61,0,0,1-.93-2.56,12.76,12.76,0,0,1-.21-2.67c0-1.75,0-3.49,0-5.2v-7.63c0-.83,0-1.66.07-2.51a9.73,9.73,0,0,1,5.58-7.68,10.17,10.17,0,0,1,4.64-.89H397.4l15.51,0,22.39.08,6.06,0,1.58,0c.36,0,.54,0,.54,0l-.54,0-1.58,0-6.06,0-22.39.09-15.51,0H384.21a9.57,9.57,0,0,0-4.44.85,9.21,9.21,0,0,0-5.29,7.3,22.27,22.27,0,0,0-.06,2.46v12.83a12.22,12.22,0,0,0,.2,2.57,10.22,10.22,0,0,0,.89,2.42,9.32,9.32,0,0,0,3.61,3.68,9.66,9.66,0,0,0,5.11,1.18h.26v8.78l-.44-.19,9.59-8.51.07-.07h.1l37.25,0h8.26c2.67-.08,5.33.33,7.6-.66a9.24,9.24,0,0,0,5.78-8c.06-1.08,0-2.18,0-3.23,0-4.22,0-8,0-11.35a10.77,10.77,0,0,0-.69-4.5,9.52,9.52,0,0,0-2.15-3.15,9.12,9.12,0,0,0-2.51-1.74,10.78,10.78,0,0,0-1.13-.46l-1-.26A17.58,17.58,0,0,0,443.48,164.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,181.11l1.92,1-1.09,1.8-2-1.18.06,2.16h-2.14l.05-2.16-2,1.18-1.07-1.8,1.91-1-1.91-1.05,1.07-1.81,2,1.21-.05-2.19h2.14l-.06,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.52,181.11l1.92,1-1.09,1.8-2-1.18.06,2.16h-2.14l0-2.16-2,1.18-1.07-1.8,1.91-1-1.91-1.05,1.07-1.81,2,1.21,0-2.19h2.14l-.06,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.42,181.11l1.92,1-1.09,1.8-2-1.18.05,2.16h-2.14l.05-2.16-2,1.18-1.07-1.8,1.91-1-1.91-1.05,1.07-1.81,2,1.21-.05-2.19h2.14l-.05,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,181.11l1.92,1-1.09,1.8-2-1.18.05,2.16h-2.14l.05-2.16-2,1.18-1.07-1.8,1.92-1-1.92-1.05,1.07-1.81,2,1.21-.05-2.19h2.14l-.05,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.22,181.11l1.92,1-1.09,1.8-2-1.18.05,2.16H425l.05-2.16-2,1.18-1.07-1.8,1.92-1L422,180.06l1.07-1.81,2,1.21-.05-2.19h2.14l-.05,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.12,181.11l1.92,1L438,184l-2-1.18,0,2.16h-2.14l.05-2.16L432,184l-1.07-1.8,1.92-1-1.92-1.05,1.07-1.81,2,1.21-.05-2.19H436l0,2.19,2-1.21,1.09,1.81Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1,219.63c11.8,6.11,20.84,16.63,27.34,28.21s10.7,24.29,14.85,36.91l3.63,65.07C84.2,326.48,73.18,299,70.21,272.11l9.13-.81c-6.12-.94-11.26-5.37-14.53-10.63s-5-11.33-6.6-17.3L69.35,245A41.29,41.29,0,0,1,52.1,219.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1,219.63c11.8,6.11,20.84,16.63,27.34,28.21s10.7,24.29,14.85,36.91l3.63,65.07C84.2,326.48,73.18,299,70.21,272.11l9.13-.81c-6.12-.94-11.26-5.37-14.53-10.63s-5-11.33-6.6-17.3L69.35,245A41.29,41.29,0,0,1,52.1,219.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,365.07s29.79-35.65,29.45-69.69h-12s13.07-8.6,12-13.41-1.38-23-1.38-23l-11,2.75s8.25-4.13,9.28-10.66-2.4-36.79-2.4-36.79-13.41,14.1-17.54,28.54-15,31.28-11.77,75.29S100,365.07,100,365.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.85,368.44s-32.27-21.5-39.44-48.94l9.67-2.64s-12.38-4.05-12.61-8.14-3.93-18.82-3.93-18.82l9.45-.2s-7.54-1.51-9.8-6.54-6.11-30.1-6.11-30.1,13.86,8.4,20.34,19.11,18.87,21.88,25.94,57.95S84.85,368.44,84.85,368.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,245.33a2.18,2.18,0,0,1-.05.38l-.21,1.11c-.2,1-.48,2.43-.85,4.25s-.83,4.1-1.32,6.73-1.09,5.61-1.67,8.92c-1.23,6.62-2.54,14.52-3.89,23.32s-2.64,18.48-3.84,28.68-2.08,19.94-2.81,28.81-1.22,16.87-1.53,23.59c-.19,3.36-.3,6.4-.41,9.07s-.19,5-.24,6.85-.12,3.31-.15,4.33c0,.48,0,.85-.05,1.13a2.28,2.28,0,0,1,0,.38,2.21,2.21,0,0,1,0-.38c0-.28,0-.65,0-1.13,0-1,0-2.47,0-4.33s.07-4.19.16-6.86.16-5.72.33-9.08c.27-6.73.76-14.73,1.42-23.61s1.61-18.62,2.78-28.83,2.53-19.9,3.87-28.7,2.73-16.69,4-23.3c.6-3.32,1.22-6.3,1.75-8.92s1-4.87,1.41-6.71.72-3.24.94-4.23l.26-1.1A2.18,2.18,0,0,1,115.76,245.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,386.9s27.26-30.93,35.72-49.62l-6.39-2.73c4.63.76,9.38-1.23,13-4.25s6.23-7,8.81-10.92L146.79,318a31.32,31.32,0,0,0,18.39-14.25c-9.94,1.64-18.92,7.09-26.33,13.91A131.55,131.55,0,0,0,122.9,336.1a62.65,62.65,0,0,0-6.19,10.19C112.13,355.76,104.07,375.55,104.09,386.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,271.06a2,2,0,0,1,.18.29c.11.23.27.51.46.88.42.8,1,1.94,1.75,3.39,1.52,2.94,3.65,7.23,6.2,12.58s5.49,11.75,8.62,18.92,6.41,15.14,9.68,23.56,6.15,16.54,8.69,23.95,4.65,14.13,6.35,19.8,3,10.28,3.88,13.48l1,3.68.25,1a1.42,1.42,0,0,1,.06.33,1,1,0,0,1-.11-.32c-.08-.23-.18-.55-.3-.94-.25-.87-.61-2.1-1.07-3.66-.92-3.18-2.29-7.77-4-13.42s-3.93-12.35-6.46-19.76-5.47-15.48-8.72-23.91-6.55-16.37-9.63-23.56-6-13.6-8.52-19-4.57-9.67-6-12.64l-1.66-3.43c-.18-.38-.32-.67-.42-.9A1.76,1.76,0,0,1,45,271.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.77,400.16a2.82,2.82,0,0,1,0-.58c0-.44.1-1,.16-1.66s.18-1.6.34-2.61.31-2.18.56-3.45c.44-2.55,1.11-5.56,2-8.87s2-6.89,3.4-10.59,2.94-7.14,4.45-10.21,3-5.76,4.38-8c.65-1.12,1.3-2.09,1.86-3s1-1.59,1.47-2.18.71-1,1-1.35a2.42,2.42,0,0,1,.37-.46,3.13,3.13,0,0,1-.28.52l-.89,1.4c-.4.61-.87,1.35-1.4,2.23s-1.16,1.86-1.79,3c-1.3,2.22-2.76,4.93-4.26,8s-3,6.5-4.39,10.18-2.51,7.26-3.43,10.54-1.59,6.28-2.08,8.81c-.27,1.26-.45,2.41-.63,3.42s-.32,1.88-.43,2.6-.19,1.21-.26,1.64A2.64,2.64,0,0,1,101.77,400.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 392.88,
    width: 59.66,
    height: 12.17,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.78 405.05 113.33 445.99 77.28 445.99 71.26 405.05 119.78 405.05",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.46,405.05c0-.14,11.29-.26,25.21-.26s25.21.12,25.21.26-11.29.26-25.21.26S69.46,405.2,69.46,405.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.18,400.4s71.71-37.36,87.26-16.75-15.61,36.8-21.63,40.44-66.93,24.33-66.93,24.33l-16.07-17.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.46,420.39l28.59,15.39,26.13,5.66a3.34,3.34,0,0,1,2.49,4.18h0a3.28,3.28,0,0,1-2.09,2.21c-6.49,2.26-30.38,10.45-32.41,9.21-2.35-1.44-31.24-14.24-31.24-14.24Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.67,445.62,416.22,456l1.22.63a5,5,0,0,0,3.44.41c3.09-.73,11.59-3,29.65-9.16a3.32,3.32,0,0,0,2.14-2.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.91,445.35a2,2,0,0,1,2.59.7,1.94,1.94,0,0,1-.67,2.58,2.13,2.13,0,0,1-2.74-.76,2,2,0,0,1,1-2.6",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.66,445.79c.16-.12-1-1.55-1-3.68s1.22-3.53,1.06-3.66-.47.19-.91.82a5.22,5.22,0,0,0-.86,2.83,5.16,5.16,0,0,0,.78,2.85C436.19,445.59,436.6,445.85,436.66,445.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.58,445.7c.2-.07-.27-1.48.06-3.19s1.24-2.87,1.08-3-1.43.92-1.78,2.88S441.43,445.82,441.58,445.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.74,447.1c.2-.07-.53-2.23-.24-4.94s1.38-4.7,1.19-4.8-1.63,1.82-1.9,4.73S429.59,447.2,429.74,447.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.66,443.14c.21,0,.35-1.92,1.34-4s2.32-3.51,2.18-3.67-1.8,1.08-2.83,3.37S420.47,443.17,420.66,443.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,438.84c.21,0,.07-2.11,1.29-4.25s3-3.17,2.91-3.35-.56.06-1.28.53a7.06,7.06,0,0,0-2.26,2.47,7.18,7.18,0,0,0-.9,3.23C411.9,438.33,412.06,438.85,412.15,438.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,433.82s-.33-.3-1.07-.6a8.52,8.52,0,0,0-3.31-.59,3.81,3.81,0,0,0-2.35.62,1.37,1.37,0,0,0-.42,1.48,2.21,2.21,0,0,0,1.08,1.13,4.7,4.7,0,0,0,5.74-1.7,5.44,5.44,0,0,0-.11-6.07,1.88,1.88,0,0,0-1.36-.8,1.32,1.32,0,0,0-1.24.91,4.64,4.64,0,0,0,0,2.41,9.42,9.42,0,0,0,1.24,3.12c.43.67.74,1,.78,1a15,15,0,0,1-1.52-4.17,4.27,4.27,0,0,1,0-2.1.69.69,0,0,1,.67-.5,1.28,1.28,0,0,1,.87.58,4.85,4.85,0,0,1,0,5.26,4.08,4.08,0,0,1-4.85,1.51,1.61,1.61,0,0,1-.79-.75.73.73,0,0,1,.22-.82,3.42,3.42,0,0,1,2-.57A12.57,12.57,0,0,1,411.79,433.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.71,424.05s-67.57-40.94-76.7-46c-7.85-4.37-32.65-14-41.39,9.75s38.32,58.84,38.32,58.84l39.94,1.79,13.33-5.09L394.35,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,449.25,327.91,461l-21.28,16.17a3.33,3.33,0,0,1-4.8-.82h0a3.32,3.32,0,0,1-.32-3c2.5-6.39,11.82-29.87,14.08-30.6,2.62-.85,31.13-14.47,31.13-14.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.83,476.3l15.79-34.47-1.27.52a5,5,0,0,0-2.55,2.34c-1.45,2.83-5.29,10.74-12.33,28.49a3.34,3.34,0,0,0,.36,3.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.84,444a2,2,0,0,1-2.22,1.51,1.93,1.93,0,0,1-1.52-2.18,2.13,2.13,0,0,1,2.36-1.59,2,2,0,0,1,1.33,2.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.11,464c0,.21,1.84.23,3.42,1.67s1.89,3.22,2.09,3.18.16-.48,0-1.22a5.29,5.29,0,0,0-4.26-3.75C312.57,463.8,312.11,463.94,312.11,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,467.82c-.07.2,1.3.76,2.38,2.13s1.39,2.8,1.59,2.77.23-1.68-1-3.22S309,467.63,309,467.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.62,457.92c-.08.2,2,1.05,3.91,3s2.67,4.1,2.87,4-.32-2.42-2.36-4.52S315.64,457.74,315.62,457.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.53,453.59c-.15.15,1.23,1.52,2.2,3.65s1.16,4.05,1.37,4,.34-2.07-.72-4.34S324.63,453.43,324.53,453.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.33,449.93c-.13.16,1.56,1.41,2.4,3.74s.43,4.35.64,4.39.32-.46.44-1.32a7,7,0,0,0-.42-3.32,7.14,7.14,0,0,0-1.86-2.79C333.88,450.06,333.38,449.85,333.33,449.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.38,452.92a2.7,2.7,0,0,0,1.15-.43,8.45,8.45,0,0,0,2.6-2.13,3.74,3.74,0,0,0,1.05-2.19,1.32,1.32,0,0,0-.85-1.28,2.17,2.17,0,0,0-1.55.09,4.71,4.71,0,0,0-2.45,5.47,5.46,5.46,0,0,0,4.69,3.86,1.89,1.89,0,0,0,1.49-.52,1.32,1.32,0,0,0,.11-1.53,4.53,4.53,0,0,0-1.84-1.55,9.7,9.7,0,0,0-3.18-1.09,3,3,0,0,0-1.23,0,15.31,15.31,0,0,1,4.16,1.55,4.32,4.32,0,0,1,1.57,1.4.68.68,0,0,1-.06.83,1.29,1.29,0,0,1-1,.29,4.88,4.88,0,0,1-4-3.4,4.09,4.09,0,0,1,2-4.67,1.54,1.54,0,0,1,1.08-.11.72.72,0,0,1,.48.7,3.41,3.41,0,0,1-.85,1.87A12.56,12.56,0,0,1,337.38,452.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,456.81c.85-.44,35.06-14.37,35.06-14.37l-34-16.84L325.6,436.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.75,415.64l.47.14,1.35.45,5.17,1.79,19,6.67,62.65,22.11,3,.93-.31.14L405.49,424l.1.31-39.41-24.1-11.34-7-3-1.88-.77-.5c-.17-.11-.26-.17-.25-.18l.27.15.8.46,3.05,1.81,11.42,6.87,39.5,23.94.19.12-.09.2L394.58,448.1l-.1.2-.21-.07-3-.93c-1.57-.45-3.07-1-4.58-1.55l-4.5-1.6L373.36,441l-16.61-5.93-28.13-10-18.95-6.83-5.14-1.88-1.33-.5A3.94,3.94,0,0,1,302.75,415.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,456.81a14.15,14.15,0,0,1-1.27-1.21l-3.32-3.43c-2.79-2.91-6.62-7-10.83-11.45l-4.23-4.53-.23-.25.3-.15,10.38-5,3-1.42a8,8,0,0,1,1.11-.46,5.62,5.62,0,0,1-1,.61L336,431l-10.3,5.2.07-.4,4.25,4.52c4.21,4.49,8,8.58,10.72,11.56l3.2,3.54A9.53,9.53,0,0,1,345,456.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,390.49c.06.13-8.36,3.79-18.8,8.16s-18.94,7.82-19,7.69,8.36-3.79,18.8-8.17S414,390.35,414,390.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,287.45c-.71,0-25.38-.23-30.36,4.75s-15.32,81.25-15.32,81.25c5.32,1,8.78,3,12,4.58l41.93,24.45,18.15-9.43a4.56,4.56,0,0,0,1.28-6.93h0l24.15-87.29a44.58,44.58,0,0,0-11.76-6.4C395,289.83,362,287.45,362,287.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.71,295.55s7.42,1.64,10.26,6.22c6.66,10.73,27.12,48.84,30.56,58,3.64,9.67-.27,15.17-2.9,19.25-2.83,4.39-18.38,4.38-25.43-3.15-3-3.24-19.86-18.51-19.86-18.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.15,309.7a5.08,5.08,0,0,1-.28.75l-.91,2.12c-.75,1.85-1.8,4.54-3,7.9-2.42,6.73-5.38,16.14-8.52,26.58s-5.87,19.89-7.9,26.79c-1,3.43-1.86,6.2-2.47,8.1l-.72,2.19a4.26,4.26,0,0,1-.28.75,5.12,5.12,0,0,1,.18-.78q.24-.83.63-2.22c.56-2,1.34-4.74,2.31-8.14,1.94-6.88,4.62-16.38,7.75-26.84s6.16-19.85,8.67-26.55c1.25-3.36,2.36-6,3.17-7.86l1-2.08A4,4,0,0,1,414.15,309.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.82,291.33s-7.79,4.43-10.64,7S289.89,342.91,286.12,356c-2.19,7.58,6.16,23.26,15.16,22.5,11.77-1,55.93-17.93,55.93-17.93L347.3,339l-25,4,18.15-18.24-6.77-33.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.56,355.27a2.33,2.33,0,0,1-.44-.27l-1.22-.84L431.47,351c-3.72-2.7-8.84-6.47-14.48-10.66l-3.77-2.81.35-.05c-3.59,4.69-6.79,8.78-9.12,11.67a34.6,34.6,0,0,1-3.89,4.49l3.63-4.7,9-11.77.15-.2.2.15,3.78,2.8c5.64,4.19,10.72,8,14.39,10.79L436,354l1.16.92A2.37,2.37,0,0,1,437.56,355.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.67 331.37 347.87 340.24 355.77 357.41 368.15 349.24 367.67 331.37",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,333.05l13.25-9a2.44,2.44,0,0,1,1.59-.42l17.32,1.48a1.33,1.33,0,0,1,1.22,1.36,2.36,2.36,0,0,1-.73,1.84L390.9,347.88l-21-3.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,331.37s7.15-5.3,8.83-5.59,9.23-.26,9.23-.26l6.36,3.63-3.94,2.67c-2.73-.6-3.51-1.66-3.51-1.66l-4.4.29Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.71,329.07,387,333l16.24,2.29a3.55,3.55,0,0,1-3.24,3.65c-2,.21-5.38.44-5.38.44s-.83,3-3.36,3.65a8.29,8.29,0,0,1-2.44,2.89,2,2,0,0,1-.5.22c-1.56.45-4.67,4.68-6.75,5.25s-13.44-2.11-13.44-2.11l-.48-17.86Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,338.29c0-.05.9.19,2.33.48a43.17,43.17,0,0,0,5.69.74,41.36,41.36,0,0,0,5.72,0c1.47-.1,2.37-.23,2.38-.18a3,3,0,0,1-.63.15c-.4.08-1,.17-1.73.25a33.88,33.88,0,0,1-5.76.1,33.5,33.5,0,0,1-5.71-.84c-.72-.17-1.3-.33-1.69-.46A2.91,2.91,0,0,1,379,338.29Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.22,342.92a2.54,2.54,0,0,1-.11,1.12,2.37,2.37,0,0,1-.61,1.09,2,2,0,0,1-1.47.49,3.84,3.84,0,0,1-1.46-.42c-.41-.21-.75-.43-1.05-.59-.58-.35-1-.48-1-.53a2.33,2.33,0,0,1,1.06.33,6.71,6.71,0,0,0,2.43.9,1.72,1.72,0,0,0,1.26-.39,2.21,2.21,0,0,0,.59-.95A9.56,9.56,0,0,1,381.22,342.92Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57,344a4.91,4.91,0,0,1-1.24.32,28.08,28.08,0,0,1-3,.37,27.17,27.17,0,0,1-3.07,0,5,5,0,0,1-1.27-.14c0-.1,1.94,0,4.32-.21S389.55,343.94,389.57,344Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,348.72a4,4,0,0,1-3.88.61c0-.1.9.07,2-.1S381,348.64,381,348.72Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,348.52c0,.08-.53.22-1.21.32a2.73,2.73,0,0,1-1.26,0,2.69,2.69,0,0,1,1.22-.32C384.5,348.44,385.06,348.43,385.07,348.52Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,333a30.69,30.69,0,0,1-5.29-1.77c-1.44-.56-2.73-1.09-3.65-1.51a6.51,6.51,0,0,1-1.45-.76,11.75,11.75,0,0,1,1.53.56l3.68,1.42,3.67,1.43C386.45,332.7,387,332.92,387,333Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.59,337s-1.25-.43.1-2.4,5.13.42,5.13.42l4.83,2.87s1.08,2.51-.26,3.18l-1,1.22s1.89,1.91,1.13,3.58a2.6,2.6,0,0,1-2.63,1.44s.22,3.38-.88,4.68a3.69,3.69,0,0,1-2.1,1.42,6,6,0,0,1-4.17,3.63c-3.24.83-4.94.89-5.82-.48a14.92,14.92,0,0,1-1.43-3.09s-6.95-3.65-7.1-5.5.17-2,.17-2a3.47,3.47,0,0,1,.14-2.67c.7-1.13,3.46-.14,3.46-.14l8.87,2.08s-7.1-3.33-7.94-4.42.06-2.43,2.91-2.09,11.46,1.95,11.46,1.95a2.64,2.64,0,0,0-1-1.1c-.57-.24-2.35-1.27-2.35-1.27Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.71,350.47c0,.08-3.62-.84-8-2.05s-8-2.27-7.95-2.35,3.62.84,8,2.05S405.73,350.39,405.71,350.47Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,355.3a10.22,10.22,0,0,1-2.59-.66,18.2,18.2,0,0,1-1.77-.68,3.31,3.31,0,0,1-.52-.28.68.68,0,0,1-.12-.11s0-.09,0-.07,1.1.38,2.49.84A13.75,13.75,0,0,1,401.48,355.3Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.08,346.57c0,.08-1.75-.27-3.89-.62s-3.89-.58-3.88-.67a18.25,18.25,0,0,1,3.93.37A17.61,17.61,0,0,1,409.08,346.57Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,342c-.06.08-.76-.42-1.74-.77s-1.83-.44-1.83-.53a3.28,3.28,0,0,1,1.94.24A3.33,3.33,0,0,1,411.25,342Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,326.72l-.32,0-.93-.11c-.8-.11-2-.26-3.39-.42-2.87-.33-6.85-.68-11.26-.78a6.24,6.24,0,0,0-3.08.36,13,13,0,0,0-1.26.83l-1.2.85-4.15,2.93-2.81,1.95-.78.52c-.17.12-.27.17-.28.16a2.75,2.75,0,0,1,.25-.21l.74-.56,2.76-2,4.11-3,1.19-.86a14.45,14.45,0,0,1,1.29-.86,3.63,3.63,0,0,1,1.59-.4c.55,0,1.09,0,1.64,0a108.35,108.35,0,0,1,11.27.87c1.44.19,2.6.38,3.39.52l.92.17A1,1,0,0,1,419,326.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.15,328.26a.84.84,0,0,0-.83-.32h0l-.14,0h0a1.18,1.18,0,0,0-.68.38.72.72,0,0,0,0,.91.83.83,0,0,0,.49.23,1.22,1.22,0,0,0,1-.25A.84.84,0,0,0,408.15,328.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,232.1l-1.92-1a4.08,4.08,0,0,0-2.93-.68c-.95.27-1.61,1.18-2.59,1.28-1.14.13-2.08-.9-3.22-.84s-1.93,1-3,1c-.8,0-1.65-.57-2.34-.18-.14.08-.26.19-.39.28a2.84,2.84,0,0,1-2.66-.15,3.67,3.67,0,0,0-2.66-.46,4.23,4.23,0,0,0-1.38,1.11,1.91,1.91,0,0,1-1.61.66c-.33-.07-.6-.28-.93-.36-1-.26-1.89.84-2.94,1.12s-2.1-.22-3,.22a1.53,1.53,0,0,0-.74,1.88,2.32,2.32,0,0,0,1.74,1.31,4.82,4.82,0,0,0,2.35-.17,5.7,5.7,0,0,1,1.89-.43c1.49.05,2.66,1.59,4.12,1.27a5.14,5.14,0,0,0,1.8-1.14,5,5,0,0,1,2.9-.94,5.6,5.6,0,0,0,2.05-.11c.79-.32,1.24-1.15,2.06-1.37s1.76.31,2.67.22c.59-.05,1.14-.38,1.74-.41.85-.05,1.62.5,2.47.43s1.6-.79,2.47-.72a5.86,5.86,0,0,1,1,.27,1.08,1.08,0,0,0,1-.15c.19-.18.25-.47.48-.6a1,1,0,0,1,.58-.06l2.82.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,232c-.95-.7-2.22-1.43-3.29-.84-.39.21-.68.56-1.07.75-.9.42-2-.13-2.94.13-.81.23-1.35,1-2.1,1.35-1.21.6-3,.25-3.74,1.31-.41.58-.48,1.51-1.19,1.67a1.77,1.77,0,0,1-.76-.09,6.34,6.34,0,0,0-2.64-.08,2.81,2.81,0,0,0-1.37.58c-.72.65-.74,1.76-1.43,2.44-1,1-2.87.53-4.19,1.18a8.2,8.2,0,0,0-1.61,1.33,18.26,18.26,0,0,1-3.4,2.07,7.38,7.38,0,0,0-3,2.53,2.68,2.68,0,0,0,.38,3.43,1.36,1.36,0,0,0,1.69.08c.15-.14.25-.34.39-.5a3.31,3.31,0,0,1,1.17-.59c.41-.16.84-.47.84-.89,0-.26-.15-.57.06-.75a.63.63,0,0,1,.31-.1c1.06-.11,2.36-.06,2.93-.92a6.13,6.13,0,0,0,.43-1.27A2.38,2.38,0,0,1,349,243.4c.65-.15,1.38-.05,1.9-.45s.61-1.31,1.14-1.81c.89-.84,2.65-.23,3.45-1.14.2-.23.31-.52.56-.69.72-.47,1.59.5,2.44.34s1-1,1.51-1.48a8.73,8.73,0,0,1,2.47-1.14c1.05-.51,1.81-1.5,2.92-1.83,1-.29,2.14-.09,2.85-.77.27-.26.46-.63.83-.75a1.63,1.63,0,0,1,.66,0,5,5,0,0,0,3.17-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.19,234.54a8,8,0,0,0-6.78,2,5.35,5.35,0,0,1-1.28,1,7.18,7.18,0,0,1-2.5.28,4.92,4.92,0,0,0-4.13,3.34c-.38,1.15-.52,2.66-1.63,3.06a3.42,3.42,0,0,0-.61.22c-.74.46-.23,1.64-.24,2.55,0,1.5-1.68,2.53-1.74,4a3.88,3.88,0,0,0,.39,1.59q.87,2.15,1.91,4.2c.31.61.72,1.29,1.38,1.38,1,.13,1.54-1,1.82-2a2.91,2.91,0,0,0,.06-2.09c-.28-.53-.85-.84-1.1-1.39-.39-.87.24-1.84.69-2.67a8,8,0,0,0,.77-5.51c1-.19,1.53-1.61,2.57-1.81a6.27,6.27,0,0,0,.87-.11c.69-.28.77-1.33,1.38-1.76s2-.1,2.34-.95c.1-.27.05-.59.22-.81a.85.85,0,0,1,.55-.29l2.52-.63a2.91,2.91,0,0,0,1.34-.59c.65-.62.75-1.8,1.57-2.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.86,229.53c-.1-1.48-.38-3.26-1.69-3.86-.77-.36-1.71-.17-2.47-.56-1.46-.73-1.58-3.09-3-3.84s-3.32.41-4.46-.69c-.59-.57-.67-1.52-1.15-2.19a3.34,3.34,0,0,0-2.57-1.1,8.09,8.09,0,0,1-2.82-.38c-1.5-.66-2.46-2.52-4.07-2.65-1.37-.1-2.44,1.1-3.3,2.2a2.11,2.11,0,0,0-.49.92,1.61,1.61,0,0,0,.89,1.51c1.09.64,2.49.54,3.5,1.29a10,10,0,0,0,1.09.88c.58.31,1.31.24,1.87.59,1.09.67,1.07,2.5,2.16,3.18s2.36-.12,3.54.15c1.6.38,2.48,2.61,4.12,2.67a15.77,15.77,0,0,0,2.12-.47,2.35,2.35,0,0,1,2.27,1.34c.26.56.3,1.22.61,1.76a2.55,2.55,0,0,0,1.89,1.19,7.17,7.17,0,0,0,2.26-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.62,234.14c-1-1.89-2.23-3.91-4.28-4.79a26.56,26.56,0,0,1-3.18-1.11c-.82-.48-1.4-1.25-2.17-1.8-1.79-1.27-4.26-1.19-6.46-.84s-4.47.9-6.63.37c-1.94-.48-3.63-1.79-5.62-1.91a9.68,9.68,0,0,0-3.19.55l-3.62,1a1.68,1.68,0,0,0-1,.6c-.39.65.37,1.4,1.09,1.7a6.64,6.64,0,0,0,3.74.4,9.18,9.18,0,0,1,3-.45,19.67,19.67,0,0,1,2,.64,7.5,7.5,0,0,0,2.59,0l4-.42a5.61,5.61,0,0,1,3.05.26c.72.35,1.29,1,2.09,1.1s1.74-.56,2.63-.43c1.06.17,1.59,1.35,2.56,1.8,1.14.53,2.64-.09,3.74.52.75.41,1.07,1.25,1.55,1.94a4.84,4.84,0,0,0,1.53,1.42,10.4,10.4,0,0,0,2.57.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.74,225.74c-.48-.66-1.21-1.33-1-2.13.1-.39.42-.71.49-1.11.12-.72-.61-1.28-.88-2s0-1.8-.46-2.54-1.52-.89-2.4-1.11a3,3,0,0,1-2.24-1.75,10.3,10.3,0,0,1-.12-2A3.78,3.78,0,0,0,363.5,210a3.94,3.94,0,0,1-1.5-.17c-.85-.4-1-1.49-1.53-2.3A3.18,3.18,0,0,0,357.2,206c-.6.12-1.26.75-.91,1.25.14.2.4.28.59.44.68.58.19,1.75.59,2.54s1.68,1,2.07,1.84c.3.65-.05,1.46.23,2.12.35.81,1.4,1,2.28,1s1.93.24,2.26,1a4.83,4.83,0,0,1,.17,1.14,2.23,2.23,0,0,0,1.15,1.59c.85.43,2,.35,2.55,1.16s-.25,2.2.26,3.15c.37.69,1.26.87,1.93,1.29a.76.76,0,0,1,.35.4.85.85,0,0,1-.12.53c-.53,1.08-1.2,2.32-.69,3.4a4.47,4.47,0,0,0,.92,1.12,9.47,9.47,0,0,1,2.32,4l.93-4.07A4.17,4.17,0,0,0,373.74,225.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.9,212a2.73,2.73,0,0,0-1.18-3.15,2.15,2.15,0,0,0-3,1.13c-.4,1.33.72,2.89,0,4.09a4.25,4.25,0,0,0-.61.95c-.25.88.85,1.62.86,2.54s-1.27,1.57-1.53,2.55.83,2.31.42,3.4a4,4,0,0,1-.53.82c-1.17,1.72-.57,4,.07,6l2.65-.39c-.49-1.84,2.1-3.68,1.22-5.36-.42-.8-1.57-1.38-1.31-2.25a1.71,1.71,0,0,1,.4-.6l2.47-2.7a2.49,2.49,0,0,0,.79-1.37c.11-1.17-1.35-1.93-1.54-3.1C378,213.64,378.63,212.83,378.9,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.81,227c-.25-.87-1.38-1.13-2.27-1-2.46.38-4.26,2.44-5.83,4.36a52,52,0,0,0-4.86,6.61,4.38,4.38,0,0,0-.68,1.68,1.7,1.7,0,0,0,.62,1.62,1.07,1.07,0,0,0,1.55-.36l.73-.18a35.66,35.66,0,0,1,9.34-10.42C379.18,228.71,380.07,227.9,379.81,227Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,264.62a85.68,85.68,0,0,1-.91-14.66,29.77,29.77,0,0,1,3.92-14c.39-.64,3.45-4.8,4.16-4.59.51.15-1.66,4.17-1.48,4.67,1.66,4.79,1.33,10.1,0,15a66.09,66.09,0,0,1-5.66,13.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,296.56c.7-3.39,1.26-6.06,1.29-6.06s11.89,1.1,14.91-10.31c1.46-5.51,3.53-17.1,5.29-27.61a22,22,0,0,0-16.32-25l-1.11-.28c-12.08-2.29-20.78,6.68-22.74,18.82l-8.21,42.24L380,308.14Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,290.5a28.49,28.49,0,0,1-13.79-8.15s1.54,9.24,13.21,11.08Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.72,261.66a1.68,1.68,0,0,1-2,1.25,1.61,1.61,0,0,1-1.31-1.9,1.69,1.69,0,0,1,2-1.25A1.6,1.6,0,0,1,403.72,261.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.92,256.71c-.25.16-1.26-1.06-3-1.5s-3.27.12-3.41-.15c-.06-.12.24-.45.9-.72a4.72,4.72,0,0,1,2.8-.14,4.44,4.44,0,0,1,2.34,1.46C406,256.21,406.05,256.64,405.92,256.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,258.59a1.69,1.69,0,0,1-2,1.26,1.61,1.61,0,0,1-1.31-1.9,1.68,1.68,0,0,1,2-1.25A1.6,1.6,0,0,1,387.77,258.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.52,253.09c-.26.16-1.27-1.06-3-1.5s-3.27.12-3.41-.15c-.07-.11.23-.45.9-.71a4.6,4.6,0,0,1,2.79-.15,4.36,4.36,0,0,1,2.34,1.46C388.56,252.59,388.64,253,388.52,253.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.43,268.19a12,12,0,0,1,3,.2c.46.07.91.09,1.06-.2a2.33,2.33,0,0,0,0-1.41c-.15-1.19-.3-2.44-.47-3.75-.62-5.33-.94-9.67-.73-9.69s.89,4.28,1.51,9.61c.15,1.31.28,2.56.41,3.76a2.68,2.68,0,0,1-.21,1.82,1.19,1.19,0,0,1-.9.47,2.64,2.64,0,0,1-.79-.09A11.88,11.88,0,0,1,391.43,268.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,268.11c.29.05-.19,2,1.11,3.73s3.38,2.06,3.32,2.33-.54.26-1.41.07a4.94,4.94,0,0,1-2.8-1.85,4.25,4.25,0,0,1-.81-3.09C385.49,268.48,385.82,268.06,386,268.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.22,245.93c-.3.44-2-.23-4.12-.5s-3.94-.13-4.1-.63c-.07-.23.33-.61,1.12-.9a7.14,7.14,0,0,1,6.26.86C390.06,245.25,390.35,245.72,390.22,245.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67,250.68c-.41.32-1.52-.39-3-.78s-2.76-.41-2.94-.9c-.07-.23.22-.58.86-.83a4.47,4.47,0,0,1,4.76,1.36C406.79,250.07,406.85,250.52,406.67,250.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2,254.88c-.18-.13-7.28-4.3-9,3.58s6.56,8,6.62,7.76S368.2,254.88,368.2,254.88Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06,262.71s-.16.07-.41.12a1.38,1.38,0,0,1-1-.2c-.77-.49-1.18-2-.91-3.39a4.52,4.52,0,0,1,.81-1.88,1.61,1.61,0,0,1,1.26-.83.71.71,0,0,1,.73.55c.06.24,0,.39,0,.41s.2-.09.21-.43a.9.9,0,0,0-.2-.56,1.05,1.05,0,0,0-.72-.37,2,2,0,0,0-1.7.91,4.86,4.86,0,0,0-1,2.09c-.29,1.6.2,3.27,1.27,3.85a1.53,1.53,0,0,0,1.3.06C364,262.9,364.08,262.73,364.06,262.71Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18,238.42c1.43-.44-1.55-5.38-4.39-7.46-4.3-3.14-11.28-6-15.92-5.65-5.58.39-10.51,2.1-14.15,6.35a31.75,31.75,0,0,0-6.8,15.14,9.64,9.64,0,0,0,.11,5.06c.74,2,2.63,3.52,2,5.91a3.36,3.36,0,0,0,.32,2.58c1.12,1.84,3.19.76,4.31-.52,2.38-2.73,3.34-6.38,4.23-9.9a23.28,23.28,0,0,0,1.07-7.61c-.11-1.4-.47-2.78-.51-4.18a4.88,4.88,0,0,1,1.39-3.83,6,6,0,0,1,.77-.51,8.4,8.4,0,0,1,8.5.15c4.12,2.5,11.23,6.43,13.53,5.34,3.31-1.58,4.29-2.85,4.29-2.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.11,372.94a3.16,3.16,0,0,1,.64-.28l1.87-.73,7.06-2.64,24.44-9-.14.34c-2-4.41-4.24-9.21-6.54-14.18l-3.37-7.35.27.14L322.86,343h0a49.53,49.53,0,0,0-12.65,5.56c-1.4.86-2.45,1.6-3.17,2.1l-.8.58a1,1,0,0,1-.29.18l.25-.23.77-.62c.69-.54,1.73-1.31,3.12-2.2a47.88,47.88,0,0,1,12.66-5.75h0l24.47-3.82.19,0,.09.17c1.09,2.39,2.23,4.85,3.38,7.35,2.28,5,4.49,9.77,6.51,14.19l.12.24-.26.1-24.51,8.8-7.1,2.51-1.9.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.76,328a17.13,17.13,0,0,1-2,2.46c-1.3,1.47-3.12,3.47-5.19,5.64s-4,4.08-5.45,5.39a16.22,16.22,0,0,1-1.82,1.47c-.25.14-.42.28-.64.24a.15.15,0,0,1,0-.2s0-.05,0-.05,0,.13.06.15a1.41,1.41,0,0,0,.48-.3c.41-.34,1-.89,1.68-1.57,1.39-1.38,3.27-3.33,5.33-5.49l5.3-5.53A19.39,19.39,0,0,1,337.76,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52,318.12c-.11,0,.21-1.57.21-4.1a26.32,26.32,0,0,0-.38-4.4,27.26,27.26,0,0,0-3.86-10.05,27.61,27.61,0,0,0-2.68-3.53c-1.7-1.87-3-2.81-2.9-2.89a4.59,4.59,0,0,1,.92.62,9.88,9.88,0,0,1,1,.83,16.49,16.49,0,0,1,1.25,1.19,24.71,24.71,0,0,1,2.81,3.52,27.73,27.73,0,0,1,2.52,4.9,28.6,28.6,0,0,1,1.42,5.33,24.42,24.42,0,0,1,.27,4.49,16.37,16.37,0,0,1-.13,1.72,9,9,0,0,1-.19,1.29A4.6,4.6,0,0,1,342.52,318.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,392.69c0-.09,1.26,0,3.28,0a29.84,29.84,0,0,0,14.92-4.4c1.72-1,2.7-1.84,2.76-1.77s-.2.25-.63.63a20.21,20.21,0,0,1-1.93,1.45,27,27,0,0,1-7.22,3.38,26.69,26.69,0,0,1-7.9,1.08,18.83,18.83,0,0,1-2.41-.17A3.19,3.19,0,0,1,368,392.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.88,370.61a4.33,4.33,0,0,1-.67.85c-.45.53-1.13,1.27-2,2.18-1.71,1.81-4.16,4.24-7,6.77s-5.51,4.71-7.5,6.21c-1,.75-1.81,1.35-2.39,1.74a4,4,0,0,1-.92.57,4.49,4.49,0,0,1,.8-.73l2.28-1.87c1.92-1.57,4.56-3.77,7.39-6.3s5.3-4.91,7.08-6.65l2.1-2.06C382.56,370.84,382.85,370.58,382.88,370.61Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/Sign in.6175aa0ca71d3a0369bdc43eac6df742.svg";
export { ForwardRef as ReactComponent };